import { render, staticRenderFns } from "./AmortizationTab.vue?vue&type=template&id=ffbb6af4&scoped=true&"
import script from "./AmortizationTab.vue?vue&type=script&lang=js&"
export * from "./AmortizationTab.vue?vue&type=script&lang=js&"
import style0 from "./AmortizationTab.vue?vue&type=style&index=0&id=ffbb6af4&prod&scoped=true&lang=css&"
import style1 from "./AmortizationTab.vue?vue&type=style&index=1&id=ffbb6af4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbb6af4",
  null
  
)

export default component.exports